import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TextBoxMultiCarFilter from '../UserControl/TextBoxMultiCarFilter/TextBoxMultiCarFilter';
import { TimePicker } from 'antd';
import DateTimeRange from '../UserControl/DateTimeRange/DateTimeRange';
import moment from 'moment';
import { Alert, AlertCommit } from '../../Modals/AlertBar';

import { getMainCookie, checkStatus, getFullDate, checkText, setLoader } from '../../../util/util';
import html2canvas from 'html2canvas';
import * as jsPDF from 'jspdf'
import $ from 'jquery';

import ReactToPrint from "react-to-print";
import { Chart } from "react-google-charts";

const Canvas2Image = window.Canvas2Image;
let startHistoryDate = null;
let endHistoryDate = null;
let tagsHistory = null;
let tagsDevice = [];
let myChart = null;

class ReportWorkingHours extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isClickLoadReport: '',
            selectHistoryDateRange: {
                startDate: this.getCurrentDate(new Date()),
                endDate: this.getCurrentDate(new Date()),
            },
        };
    }

    componentDidUpdate(){
        setLoader(false);
    }
    btnSearchHistoryClick() {

        console.log("btnSearchHistoryClick", this.getCurrentDate(startHistoryDate), tagsDevice);
        if (startHistoryDate == null || endHistoryDate == null )
            Alert("กรุณาใส่ข้อมูล", "วัน");
        else {

            let start = this.getCurrentDate(startHistoryDate);
            let end = this.getCurrentDate(endHistoryDate)
            let dd = this.getCurrentDate(startHistoryDate).split("-")[0];
            let mm = this.getCurrentDate(startHistoryDate).split("-")[1];
            let yyyy = this.getCurrentDate(startHistoryDate).split("-")[2];
            start = dd + "-" + mm + "-" + yyyy;
            dd = this.getCurrentDate(endHistoryDate).split("-")[0];
            mm = this.getCurrentDate(endHistoryDate).split("-")[1];
            yyyy = this.getCurrentDate(endHistoryDate).split("-")[2];
            end = dd + "-" + mm + "-" + yyyy;

            this.getChart(tagsDevice,start,end);
        }

    }
    getCurrentDate(today) {
        //let today = new Date();
        if (today == null)
            return null;
        let dd = !today.date ? today.getDate() : today.date;
        let mm = today.months == undefined ? today.getMonth() + 1 : today.months + 1; //January is 0! today
        let yyyy = !today.years ? today.getFullYear() : today.years;
        if (dd < 10) {
            dd = '0' + dd
        }
        if (mm < 10) {
            mm = '0' + mm
        }
        return (dd + '-' + mm + '-' + yyyy);
    }

    setRangeDate(sDate, eDate) {
        startHistoryDate = sDate;
        endHistoryDate = eDate;
        if (sDate && eDate && sDate != null && eDate != null) {
            startHistoryDate = sDate.toObject();
            endHistoryDate = eDate.toObject();
        }
        console.log("setRangeDate", startHistoryDate, endHistoryDate);
    }
    setMultiCar(tags) {
        tagsDevice = tags;
        console.log("tag", tagsDevice);
    }
    getChart(device_id, start,end) {
        let thisCur = this;
        let start_date = start ;
        let end_date = end ;
        const { user_id, user_name, token } = this.props;
        setLoader(true);
        fetch("http://203.150.199.244/api/report/getReportWorkingHours", {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "token": token
            },
            body: JSON.stringify({
                "devices":
                    device_id
                ,
                "start_date": start_date,
                "end_date": end_date
            })
        }).then(function (response) {
            return checkStatus(response);
        }).then((data) => {
            if(data.RESULT_STATUS == "000"){
                console.log(data)
                $("#dvWorkPrint").show();
                thisCur.setState({
                    data:data.RESULT_DATA
                })
            }
            else{
                setLoader(false);
                AlertCommit(false,data.RESULT_STATUS + ": "+data.RESULT_MESSAGE);
            }


        },
            (error) => {
                console.log("error", error)
                setLoader(false);
                return error;
            }

        )
    }
    handleClick = () => {
        const { isClickLoadReport } = this.state;
        if (isClickLoadReport === 'show') {
            this.setState({isClickLoadReport: ''});
        } else {
            this.setState({isClickLoadReport: 'show'});
        }
    }

    downloadChart(){
        console.log("downloadChart")
        // let ctx = document.getElementById("ctxMainSum");
        // let imageData = ctx.toDataURL("image/png");
        // let doc = new jsPDF('l', 'mm');
        // doc.addImage(imageData, 'PNG', 12, 10,270,170);

        // doc.save("ReportWorking.pdf");

        let thisCur = this;
        const { t, token } = this.props;
        fetch("http://203.150.199.244/api/report/exportPdf/03", {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "token": token
            },
            body: JSON.stringify({
                "title": t('ชั่วโมงการทำงาน'),
                "result_data":thisCur.state.data
            })
        }).then(function (response) {
            return checkStatus(response);
        }).then((data) => {
            //if(data.RESULT_STATUS == "000"){
                console.log(data)
                document.location.href = "http://203.150.199.244/api/report/download/"+data.file_name;
            // }
            // else{
            //     AlertCommit(false,data.RESULT_STATUS + ": "+data.RESULT_MESSAGE);
            // }


        },
            (error) => {
                console.log("error", error)
                return error;
            }

        )


    }

    render() {
        const { t, onClickBackToReportPortal } = this.props;
        const { data } = this.state;
        let rCar = [];
        let h = 500;
        if(data){

            let hoursData = [];
            data.map((car,indexCar)=>{
                hoursData = [[
                    { type: 'string', id: 'Date' },
                    { type: 'string', id: 'Name'},
                    { type: 'string', role: 'tooltip' },
                    { type: 'date', id: 'Start' },
                    { type: 'date', id: 'End' },

                ]];
                h=car.hours.length;
                car.hours.map((hours,index)=>{

                    hoursData.push(
                        [
                            hours.date + ` ${t('รวมเวลาทำงาน')} ` + hours.elapse,
                            '-',
                            "",
                            new Date(0, 0, 0, 0, 0, 0),
                            new Date(0, 0, 0, 0, 0, 0)
                        ]
                    );

                    for(let i=0;i<hours.hours.length;i++){
                        hoursData.push(
                            [
                                hours.date + ` ${t('รวมเวลาทำงาน')} ` + hours.elapse,
                                ' ',
                                hours.date + ','+ hours.hours[i].start_time + "-" + hours.hours[i].end_time + `${t('ใช้เวลา')}` + hours.hours[i].elapse,
                                new Date(0, 0, 0,parseInt(hours.hours[i].start_time.split(":")[0]), parseInt(hours.hours[i].start_time.split(":")[1]), 0),
                                new Date(0, 0, 0,parseInt(hours.hours[i].end_time.split(":")[0]), parseInt(hours.hours[i].end_time.split(":")[1]), 0),
                            ]
                        );
                    }

                    hoursData.push(
                        [
                            hours.date + ` ${t('รวมเวลาทำงาน')} ` + hours.elapse,
                            '-',
                            "",
                            new Date(0, 0, 0, 24, 0, 0),
                            new Date(0, 0, 0, 24, 0, 0)
                        ]
                    );

                });
                console.log("h",h)
                rCar.push(
                    <table style={{width:"100%",marginTop:10}}>
                            <tr>
                                <td>
                                    <b>{car.device_no} {t('เวลาทำงานทั้งหมด')} {car.total_elapse.replace(":",` ${t('ชั่วโมง')} `)} {t('นาที')}</b>
                                </td>
                            </tr>
                            <tr>
                                <td style={{height:(h*41)+50}}>
                                <Chart key={"k_"+car.device_no+h} id={"k_"+car.device_no+h}
                                    width={'99%'}
                                    height={((h*41)+50)}
                                    chartType="Timeline"
                                    loader={<div>Loading Chart</div>}
                                    data={hoursData}
                                    options={{
                                        hAxis: {
                                            format: 'HH'
                                        },


                                        colors: ['#fff','#ff7800'],
                                        allowHtml: true,

                                    }}
                                    rootProps={{ h: h }}
                                />
                                </td>
                            </tr>
                        </table>

                );
            });
        }
        return (
            <div className="gray-panel" style={{overflowX:"auto",minHeight:"calc(100vh - (50px))"}}>
                <h5 style={{ paddingLeft: '2em',cursor: 'pointer' }} onClick={onClickBackToReportPortal}>
                    <i
                        className="fa fa-arrow-left"
                        aria-hidden="true"
                        style={{ color: 'rgb(115, 134, 213)'}} />
                        <i className="fas fa-file-contract" style={{ color: '#7386D5', marginLeft:10,marginRight:5,cursor:"pointer" }} />{t('รายงานข้อมูล')}
                </h5>

                <hr />

                <h5>
                    <span className="fa-stack fa-lg" style={{ color: 'orange' }}>
                        <i className="fa fa-circle fa-stack-2x" />
                        <i className="fa fa-file-text-o fa-stack-1x" style={{ color: 'white' }} />
                    </span>
                        ชั่วโมงทำงาน
                    </h5>

                <hr />

                <div style={{alignContent:"baseLine"}} className="row">
                    <table style={{minWidth:420}}>
                        <tr>
                            <td colSpan={3}>
                                <div className="col-md-12">
                                    <i className="fas fa-shipping-fast icon-for-calendar" style={{ fontSize: 20, marginLeft: '27px',marginRight:6 }} />
                                    <div style={{ display: "inline-block",marginBottom:5 }}>
                                        <TextBoxMultiCarFilter limitSelect={5} onChange={this.setMultiCar.bind(this)} />
                                    </div>

                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <label htmlFor="example-text-input" style = {{marginBottom:0}} >{t('ระหว่างวันที่')}</label>&nbsp;

                            </td>
                            <td>
                                <div className="date" id="datetimepicker1">
                                    <DateTimeRange
                                        small={true}
                                        isBack
                                        startDateId="MyDatePicker"
                                        endDateId="your_unique_end_date_id"
                                        onSelectDate={this.setRangeDate.bind(this)} />
                                </div>
                            </td>

                            <td>
                                <div className="btn-group" style={{marginLeft:5}}>
                                    <button type="button" className="btn btn-primary btn-report " data-ext="html" onClick={(e) => this.btnSearchHistoryClick(e)} >ตกลง</button>
                                    <button type="button" name="dropdown-report" className="btn btn-primary dropdown-toggle" onClick={(e) => this.handleClick(e)}>
                                        <span className="caret" />
                                    </button>
                                    <ul className={"dropdown-menu "+this.state.isClickLoadReport} >
                                        <li className="item-text"><a onClick={this.downloadChart.bind(this)}><i className="far fa-file-pdf" style={{ color: '#007bff',fontSize:20,marginLeft:10,marginRight:2 }}/> download</a>
                                        </li>
                                        <ReactToPrint
                                            trigger={() =>
                                                <li className="item-text"><a><i className="fas fa-print" style={{ color: '#007bff',fontSize:20,marginLeft:8 }} /> print</a>
                                                </li>
                                            }
                                            content={() => this.dvPrint}
                                        />

                                    </ul>
                                </div>
                            </td>
                        </tr>
                    </table>

                </div>

                <div className="row" ref={el => (this.dvPrint = el)} style={{padding:20,backgroundColor:"#fff"}}>
                    {rCar}
                </div>
                <div className="row " id="dvWorkPrint" style={{display:"none"}}>
                    <div style={{margin:"auto"}}>
                        <button  onClick={this.downloadChart.bind(this)} type="button" style={{width:150}} className="btn btn-light border border-secondary">
                            <i className="fa fa-fw fa-file-pdf-o" style={{color: 'blue'}}/>
                            รายงานแบบ PDF
                        </button>
                        <ReactToPrint
                            trigger={() =>
                                <button type="button" className="btn btn-light border border-secondary" style={{width:150}}>
                                    <a><i className="fas fa-print" style={{ color: '#007bff',fontSize:20,marginLeft:8 }} /> พิมพ์</a>
                                </button>
                            }
                            content={() => this.dvPrint}
                        />
                    </div>
                </div>
            </div>

        );
    }
}

ReportWorkingHours.propTypes = {
    t: PropTypes.func.isRequired
}


export default ReportWorkingHours;



// WEBPACK FOOTER //
// ./src/app/view/components/Report/ReportWorkingHours.js